import { defineMessages } from 'react-intl';

const prefix =
  'app.containers.TranslationSettings.MergeKeys.MergeKeysTable.MergeKeyRow';

export const messages = defineMessages({
  deleteLabel: {
    id: `${prefix}.deleteLabel`,
    defaultMessage: 'Remove merge key',
  },
  toggleLabel: {
    id: `${prefix}.toggleLabel`,
    defaultMessage: 'Translatable',
  },
  updateError: {
    id: `${prefix}.updateError`,
    defaultMessage: 'Could not update merge key',
  },
  updateSuccess: {
    id: `${prefix}.updateSuccess`,
    defaultMessage: 'Merge key updated',
  },
});
